import React from "react";
import { ArrowRight, Shield, Zap, Sun, Wind } from "lucide-react";
import Solar from "./img/video.mp4";

const services = [
  { icon: Sun, label: "Solar" },
  { icon: Shield, label: "Security" },
  { icon: Zap, label: "Electrical" },
  { icon: Wind, label: "HVAC" },
];

function Content() {
  return (
    <div className="relative h-[85vh] sm:h-screen w-full overflow-hidden bg-black">

      <video
        src={Solar}
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-50 sm:opacity-60"
      />

      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/40 to-black/95 z-10" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-black/30 z-10" />

      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-20 z-10 pointer-events-none"
        style={{ background: 'radial-gradient(circle, #712B35 0%, transparent 70%)' }} />

      <div className="relative z-20 h-full flex flex-col items-center justify-center px-4 sm:px-6 text-center">

        {/* Service Pills */}
        <div className="flex items-center gap-2 sm:gap-3 mb-6 sm:mb-8 animate-enter-emil">
          {services.map((s, i) => (
            <span
              key={i}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[11px] font-medium tracking-wide uppercase rounded-full border"
              style={{
                color: '#d4b88a',
                borderColor: 'rgba(212,184,138,0.25)',
                background: 'rgba(212,184,138,0.06)',
              }}
            >
              <s.icon className="w-3 h-3" />
              {s.label}
            </span>
          ))}
        </div>

        <h1 className="text-4xl xs:text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-semibold leading-[1.08] tracking-tight text-white animate-enter-emil delay-100 max-w-5xl">
          We care about
          <span
            className="block mt-1 sm:mt-2 bg-clip-text text-transparent"
            style={{
              backgroundImage: 'linear-gradient(135deg, #ffffff 0%, #f3ede6 40%, #d4b88a 100%)'
            }}
          >
            your property.
          </span>
        </h1>

        <p className="mt-4 sm:mt-6 text-sm sm:text-base font-light text-white/50 max-w-lg animate-enter-emil delay-150">
          Solar, security, electrical & HVAC solutions built for modern living.
        </p>

        <div className="mt-6 sm:mt-8 flex items-center gap-3 animate-enter-emil delay-200">
          <a href="#services">
            <button
              className="group px-7 sm:px-8 py-2.5 sm:py-3 rounded-full text-sm font-semibold text-white transition-all duration-300 flex items-center gap-2"
              style={{ background: '#712B35' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#5f2b40';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(113,43,53,0.45)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#712B35';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Explore Solutions
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </a>
          <a href="/contact">
            <button
              className="group px-7 sm:px-8 py-2.5 sm:py-3 rounded-full text-sm font-medium text-white/70 transition-all duration-300 border border-white/10 hover:border-white/25 hover:text-white flex items-center gap-2"
              style={{ background: 'rgba(255,255,255,0.04)' }}
            >
              Get a Quote
            </button>
          </a>
        </div>

        {/* Bottom gradient fade */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent z-10 pointer-events-none" />
      </div>
    </div>
  );
}

export default Content;
